import { useState } from "react";

import { IconButton } from "@mui/material";
import Grid from "@mui/material/Grid";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Typography from "@mui/material/Typography";

import { userSelector } from "../../../app/main/mainSlice";
import { RecipeState } from "../../../app/recipePage/recipePage.types";
import { useAppSelector } from "../../../app/store/hooks";
import useCopyIngredients from "../../../hooks/useCopyIngredients/useCopyIngredients";
import useLogRecipeEdit from "../../../hooks/useLogRecipeEdit";
import { EventLogsEnum } from "../../../utils/events";
import { WhiteThreeDotIcon } from "../../../utils/iconRefs/recipePageIcons";
import EditRecipeName from "../editRecipeName";
import RecipeDeleteDialog from "../RecipeDeleteDialog";
import { options } from "../recipeUtils";
import { RecipeMenuOptions } from "../utils/constants";
import handleShareRecipe from "../utils/shareRecipeUtil";
import styles from './recipeBannerMenu.module.css';
import "./menuItem.css";

const RecipeBannerMenu = ({ recipe, recipeName, setRecipeName, onBack }: { recipe: RecipeState, recipeName: string, setRecipeName: React.Dispatch<React.SetStateAction<string>>, onBack: () => Promise<void> }) => {
  const [editNameDialogOpen, setEditNameDialogOpen] = useState<boolean>(false);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const handleEditMenuClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const { logRecipeEdit } = useLogRecipeEdit();
  const handleClose = () => setAnchorEl(null);

  const copyIngredients = useCopyIngredients();

  const user = useAppSelector(userSelector);

  const open = Boolean(anchorEl);
  const [deleteRecipePopup, setDeleteRecipePopup] = useState(false);


  const handleOptionClick = (option: RecipeMenuOptions, isUserCreatedRecipe: boolean) => {
    if (option === RecipeMenuOptions.DELETE_RECIPE) {
      logRecipeEdit(EventLogsEnum.APP_RECIPE_DELETION_TRIGGERED)
      setDeleteRecipePopup(true);
    }
    if (option === RecipeMenuOptions.RENAME_RECIPE) {
      logRecipeEdit(EventLogsEnum.APP_RECIPE_NAME_EDIT);
      setEditNameDialogOpen(true);
    }
    if (option === RecipeMenuOptions.SHARE_RECIPE) handleShareRecipe(isUserCreatedRecipe);
    if (option === RecipeMenuOptions.COPY_INGREDIENTS) copyIngredients();

    handleClose();
  }

  return (
    <Grid>
      <Grid>
        <IconButton
          aria-label="more"
          className={styles.three_dot_icon_btn}
          id="three-dot-btn"
          onClick={handleEditMenuClick}
        >
          <WhiteThreeDotIcon />
        </IconButton>
        <Menu
          anchorEl={anchorEl}
          id="delete-menu-icon"
          onClose={handleClose}
          open={open}
        >
          {options.map((option) => {
            if (option.userCreatedRecipeOption && recipe.metadata.created_by !== user?.id) return null;
            return (
              <MenuItem
                id={`recipe-${option.text}`}
                key={option.type}
                onClick={() => handleOptionClick(option.type, recipe.metadata.created_by === user?.id)}>
                <Grid id={`user-created-recipe-${option.type}`}
                  justifyContent='space-between'>
                  <Typography variant='captionparalell'>{option.text}</Typography>
                </Grid>
              </MenuItem>
            )
          })}
        </Menu>
        {editNameDialogOpen ? <EditRecipeName
          editNameDialogOpen={editNameDialogOpen}
          oldRecipeData={recipe}
          recipeName={recipeName}
          setEditNameDialogOpen={setEditNameDialogOpen}
          setRecipeName={setRecipeName} /> : null}

        {deleteRecipePopup ?
          <RecipeDeleteDialog
            deleteRecipePopup={deleteRecipePopup}
            onBack={onBack}
            recipe={recipe}
            setDeleteRecipePopup={setDeleteRecipePopup} />
          : null}

      </Grid>

    </Grid>
  )
}

export default RecipeBannerMenu;